export default "__VITE_ASSET__BlVMB3Zf__"